import dayjs from "dayjs";
import { IFilterState } from "reducers/filter.reducer";

export const SET_FILTER = "SET_FILTER";

export interface ISetFilterAction {
  type: typeof SET_FILTER;
  payload: {
    section: keyof IFilterState;
    filterName: string;
    filterValue: string[] | number | string | boolean | dayjs.Dayjs | null;
  };
}

export type FilterActionTypes = ISetFilterAction;

export const setFilter = (
  section: keyof IFilterState,
  filterName: string,
  filterValue: string[] | number | string | boolean | dayjs.Dayjs | null
): ISetFilterAction => ({
  type: SET_FILTER,
  payload: { section, filterName, filterValue },
});
